import { useEffect } from "react";

const useClearLocalStorage = (props) => {
  useEffect(() => {
    Object.keys(localStorage).forEach((key) => {
      clearUnclearUserApiDetails(key);
    });
  }, []);

  const clearUnclearUserApiDetails = (key) => {
    if (key.includes("userGetApi_")) {
      localStorage.removeItem(key);
    }
  };
};
export default useClearLocalStorage;
